export default class BeFine {
  constructor(el) {
    this.el = el;
    this.el.value = 1;
  }
  /* eslint-disable class-methods-use-this */
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/befine.js